/**
 * FileReference 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileReference
 */
export interface FileReference {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 文件ID */
  file_id?: string
  /** 实体类型:user/group/post/comment/message等 */
  entity_type?: string
  /** 实体ID */
  entity_id?: string
  /** 字段名:avatar/bg_image/media等 */
  field_name?: string
  /** 显示顺序(用于多文件排序) */
  display_order?: number
  /** 额外元数据 */
  metadata?: string
}

/**
 * FileReference Schema
 */
export const FileReferenceSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    file_id: {
      description: '文件ID',
      format: 'string',
      type: 'string',
      label: '文件ID',
    },
    entity_type: {
      description: '实体类型:user/group/post/comment/message等',
      format: 'string',
      type: 'string',
      label: '实体类型',
    },
    entity_id: {
      description: '实体ID',
      format: 'string',
      type: 'string',
      label: '实体ID',
    },
    field_name: {
      description: '字段名:avatar/bg_image/media等',
      format: 'string',
      type: 'string',
      label: '字段名',
    },
    display_order: {
      description: '显示顺序(用于多文件排序)',
      format: 'int',
      type: 'integer',
      label: '显示顺序',
    },
    metadata: {
      description: '额外元数据',
      format: 'string',
      type: 'string',
      label: '额外元数据',
    },
  },
  type: 'object',
}
